var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component } from 'vue-property-decorator';
import ResetService from '@/common/services/ResetService';
import { Notification } from "@/common/services/notificationService";
var ResetView = /** @class */ (function (_super) {
    __extends(ResetView, _super);
    function ResetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = new ResetService();
        _this.hardReset = false;
        _this.justDelete = false;
        _this.results = [];
        _this.baseSample = null;
        _this.purpose = null;
        _this.samples = [
            { id: '1eceb4bc-a413-4afc-b5e9-dfda0aff911a', name: 'Täytetty Ak', type: 'aidApplication' },
            { id: 'dedd8ade-b0d9-4db3-8764-bec14286aee0', name: 'Täytetty Ay', type: 'aidApplication' },
            { id: '468f3bd8-f1b1-4611-a6c5-64359eea1ebf', name: 'Täytetty C', type: 'aidApplication' },
            { id: '3abb7550-87d3-4d84-8a0e-5019a969abac', name: 'Täytetty Paikka-auki', type: 'aidApplication' }
        ];
        _this.types = [];
        _this.selectedType = null;
        return _this;
    }
    ResetView.prototype.reset = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.hardReset || confirm("Olet tekemässä järjestölle hard-resettiä. Toiminto poistaa kaikki järjestön datat ennen testidatan palautusta. Toimintoa ei voi jälkeenpäin kumota. Edetäänkö?"))) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        _a = this;
                        return [4 /*yield*/, this.service.resetTestData(this.hardReset, this.justDelete, this.selectedType == null ? "" : this.selectedType)];
                    case 2:
                        _a.results = _b.sent();
                        if (this.results.some(function (r) { return !r.ok; })) {
                            Notification.error(this, "Datan resetoinnissa tapahtui virheitä.");
                        }
                        else {
                            Notification.success(this, "Datan resetointi onnistui.");
                            this.$router.push("/");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _b.sent();
                        Notification.error(this, e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ResetView.prototype, "errors", {
        get: function () {
            return this.results.filter(function (r) { return !r.ok; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResetView.prototype, "loading", {
        get: function () {
            return this.$store.state.vuexPageModule.loading;
        },
        set: function (value) {
            this.$store.commit("vuexPageModule/SET_LOADING", value);
        },
        enumerable: false,
        configurable: true
    });
    ResetView.prototype.generate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newId, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.loading = true;
                        return [4 /*yield*/, this.service.generate(this.baseSample.id, this.purpose)];
                    case 1:
                        newId = _a.sent();
                        Notification.success(this, "Datan generointi onnistui.");
                        this.$router.push({ name: this.baseSample.type, params: { id: newId } });
                        return [3 /*break*/, 4];
                    case 2:
                        e_2 = _a.sent();
                        Notification.error(this, e_2);
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ResetView.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.service.types()];
                    case 1:
                        _a.types = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResetView.prototype.typeDisplayName = function (fqaName) {
        var fqName = fqaName.split(',')[0];
        var parts = fqName.split('.');
        var len = parts.length;
        return parts[len - 1];
    };
    ResetView = __decorate([
        Component({
            name: 'ResetView'
        })
    ], ResetView);
    return ResetView;
}(Vue));
export default ResetView;
